import { motion } from "framer-motion";

export const ShimmerLine = ({ className = "h-4" }) => (
  <div className={`relative w-full overflow-hidden bg-gray-200 rounded-md ${className}`}>
    <motion.div
      className="absolute top-0 left-0 w-2/3 h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200"
      animate={{ x: ["-100%", "100%"] }}
      transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
    />
  </div>
);